import { render } from "./UpdateCustomerPage.vue?vue&type=template&id=ee49ef54&scoped=true&ts=true"
import script from "./UpdateCustomerPage.vue?vue&type=script&lang=ts"
export * from "./UpdateCustomerPage.vue?vue&type=script&lang=ts"

import "./UpdateCustomerPage.vue?vue&type=style&index=0&id=ee49ef54&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/ZaloOA_LienChieu/ZaloOA_LienChieu_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee49ef54"]])

export default __exports__